// extracted by mini-css-extract-plugin
var _1 = "#4c4c4c";
var _2 = "debugmenu_button__xqaen";
var _3 = "640px";
var _4 = "790px";
var _5 = "#057676";
var _6 = "debugmenu_errorbuttons__bev-h";
var _7 = "#434343";
var _8 = "79px";
var _9 = "110px";
var _a = "72px";
var _b = "665px";
var _c = "debugmenu_section__r-mit";
var _d = "debugmenu_subtitle__ny81k";
var _e = "teal";
var _f = "2";
var _10 = "#cdd3dc";
export { _1 as "body", _2 as "button", _3 as "controlsMobileWidth", _4 as "controlsStackedWidth", _5 as "darkTeal", _6 as "errorButtons", _7 as "headline", _8 as "menuHeight", _9 as "menuHeightLarge", _a as "menuHeightMobile", _b as "modalMobileWidth", _c as "section", _d as "subtitle", _e as "teal", _f as "timelineStrokeWidth", _10 as "timelineTrackColor" }
